<template>
  <div class="page__row">
    <div class="profile__column d-flex flex-column flex-fill">
      <div class="upload" @click="uploadVideo">
        <div class="header font-white-26">Upload Video</div>

        <div class="desc mt-3 mb-3">
          Want to see metrics on your recent video? Upload and publish a video
          to get started.
        </div>
        <div class="upload-img">
          <img class="image" src="../assets/images/Trainerdashboard.svg" />
        </div>
        <div class="custom-button"><p>UPLOAD VIDEO</p></div>
      </div>
    </div>
    <div class="profile__column d-flex flex-column flex-fill">
      <div class="analytics">
        <div class="header font-white-26 mb-4">Analytics</div>
        <div>
          <span class="font-green-18"
            >Total Views
            <div class="i-border" id="total-views">
              <span class="info-icon notranslate">i</span>
            </div></span
          >

          <p class="font-white-36">
            {{ tenantInfo.totalViews }}
          </p>
        </div>
        <div class="stats mt-4 mb-4 pb-4">
          <div class="stats-text">
            Reach
            <div class="i-border" id="reach">
              <span class="info-icon notranslate">i</span>
            </div>
            <span class="stats-value">{{ tenantInfo.reach }}</span>
          </div>
          <div class="stats-text">
            Engagement
            <div class="i-border" id="engagement">
              <span class="info-icon notranslate">i</span>
            </div>
            <span class="stats-value"> {{ tenantInfo.engagement }}</span>
          </div>
          <div class="stats-text">
            Total Watchtime (minutes)
            <div class="i-border" id="total-watchtime">
              <span class="info-icon notranslate">i</span>
            </div>
            <span class="stats-value">{{ tenantInfo.totalWatchtime }}</span>
          </div>
        </div>
        <div v-if="topVideo.title" class="top-video">
          <div class="d-flex">
            <div class="w-50">
              <p class="top-video font-green-18">Top Video</p>
              <div
                class="title top-video-title font-white-18"
                :title="topVideo.title"
              >
                {{ topVideo.title }}
              </div>
              <p class="views font-white-18">
                {{ kFormatter(topVideo.video_views) }} views
              </p>
            </div>
            <div>
              <b-img :src="topVideo.thumbnail" height="100" width="170"></b-img>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-video
      v-if="addVideo"
      :videoData="videoData"
      @exit="closeModal"
    ></add-video>
    <b-tooltip
      custom-class="custom-tooltip"
      target="total-views"
      title="Tooltip title"
    >
      All user views combined
    </b-tooltip>
    <b-tooltip target="reach" title="Tooltip title">
      Unique number of users
    </b-tooltip>
    <b-tooltip target="engagement" title="Tooltip title">
      Average number of videos watched per user per day </b-tooltip
    ><b-tooltip target="total-watchtime" title="Tooltip title">
      Total number of workout minutes across all users
    </b-tooltip>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState, mapGetters, mapActions } = createNamespacedHelpers(
  "admin/trainerProfileView"
);
import AddVideo from "../components/videos/AddVideo.vue";
export default {
  data: function () {
    return {
      addVideo: false,
      videoData: {},
    };
  },

  methods: {
    ...mapActions(["loadTenantData"]),

    uploadVideo() {
      this.addVideo = true;
    },
    closeModal(data) {
      this.addVideo = false;
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },
  },
  components: {
    AddVideo,
  },

  computed: {
    ...mapGetters(["tenantInfo"]),

    topVideo() {
      if (this.tenantInfo.topVideo && this.tenantInfo.topVideo.length) {
        return this.tenantInfo.topVideo[0];
      } else {
        return {};
      }
    },
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setSelectedTenant") {
        this.loadTenantData();
      }
    });
  },

  beforeDestroy() {
    this.unsubscribe();
  },
  async mounted() {
    await this.loadTenantData();
  },
};
</script>

<style lang="scss" scoped>
.page__row {
  background: #5c6567;
}
.profile__column {
  float: left;
  width: 35%;
  height: 75%;
  background: #3d4248;
  margin: 5% 0 10% 10%;
}

.upload {
  height: 100%;
  padding: 5%;
  cursor: pointer;
}
.analytics {
  height: 100%;
  padding: 5%;
}

.desc {
  text-align: center;
  color: #bcbec0;
  font-size: 18px;
  font-family: Kanit-Regular, Kanit;
}

.stats {
  border-bottom: 1px solid #73bc44;
  .stats-text {
    color: #bcbec0;
    font-size: 18px;
    font-family: Kanit-Regular, Kanit;
  }
  .stats-value {
    float: right;
    color: #ffffff;
    font-size: 18px;
    font-family: Kanit-Regular, Kanit;
  }
}
.image {
  height: 150px;
  width: 250px;
  margin: 30px auto;
  display: flex;
}
.views {
  color: #bcbec0;
}
.top-video-title {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
